import { TWITCH_STREAM_INIT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { gatewayEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'

export default {
	[TWITCH_STREAM_INIT]: {
		endpointType: gatewayEndpointType,
	},
}
